import { useEffect, useState } from "react"
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../../theme/Component/BasicTable"
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _UBLTaxWithHoldingTax } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";

interface Props {
    HoldingTax: any;
}

export const TaxHoldValueListByIDUBLTaxWithHoldingTax = ({ HoldingTax }: Props) => {
    const { instance, setBean, bean, lista, setLista } = useDataBean(_UBLTaxWithHoldingTax);

    useEffect(() => {
        getLista();
    }, [HoldingTax])

    const [head, setHead] = useState(
        [
            // { title: 'ID', property: 'IDTaxSchemeValue', visible: true, mask: MASK_NUMBER },
            { title: 'Descripción', property: 'Description', visible: true },
            { title: 'Concepto', property: 'TaxHoldName', visible: true },
            { title: 'Valor', property: 'TaxHoldValue', visible: true, mask: MASK_MONEY },
        ]
    )

    const getLista = () => {
        instance.getTaxHoldValueListByIDUBLTaxWithHoldingTax(HoldingTax.IDUBLTaxWithHoldingTax, HoldingTax.IssueDate).then(
            (resp) => {
                console.log(resp)
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <BasicTable body={lista} head={head} rowSet={setBean} />
    )
}